import { TestContext } from 'yup'
import { CountryCodes } from 'constants/Countries'
import { AccountContactFormKeys } from './constants'

export const getIsValidPersonalIdNumber = (personalIdNumber: string, context: TestContext, t) => {
  const nationality = context?.parent?.[AccountContactFormKeys.NATIONALITY]
  if (!personalIdNumber || !nationality) return true
  const patternByNationality = {
    [CountryCodes.US]: '^(?!000|666)[0-8]\\d{2}-?(?!00)\\d{2}-?(?!0000)\\d{4}$',
  }
  const nationalitiesWithValidation = Object.keys(patternByNationality)
  if (nationalitiesWithValidation?.includes(nationality)) {
    const isValid = new RegExp(patternByNationality?.[nationality]).test(personalIdNumber)
    return (
      isValid ||
      context?.createError({
        message: t('formFields.personalIdentificationNumberPatternError'),
        path: AccountContactFormKeys.PERSONAL_IDENTIFICATION_NUMBER,
      })
    )
  }
  return true
}
